__turbopack_context__.v({
  "className": "sohne_f191bec8-module__0Io5rG__className",
});
